import { useEffect } from 'react'
import { SITE } from './config'

/**
 * Loads the Google tag (gtag.js) once and configures every id that is set: the
 * Google Ads tag (SITE.ANALYTICS_ID) and the GA4 analytics tag (SITE.GA4_ID). With
 * no ids it does nothing (no script, no cookies). Client-side only; safe during SSG.
 */
export function useAnalytics() {
  useEffect(() => {
    const ids = [SITE.ANALYTICS_ID, SITE.GA4_ID].filter(Boolean)
    if (!ids.length || typeof window === 'undefined' || document.getElementById('ga4-src')) return
    const s = document.createElement('script')
    s.id = 'ga4-src'
    s.async = true
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`
    document.head.appendChild(s)
    const w = window as unknown as { dataLayer: unknown[]; gtag: (...a: unknown[]) => void }
    w.dataLayer = w.dataLayer || []
    w.gtag = function gtag() {
      w.dataLayer.push(arguments)
    }
    w.gtag('js', new Date())
    for (const id of ids) w.gtag('config', id)
  }, [])
}

/**
 * Fires the Google Ads "Submit lead form" conversion. Call this on a successful
 * form submission (volunteer, contact, referral, partner). No-op if conversion
 * tracking is off or the Google tag has not loaded. The form shows an inline
 * thank-you instead of a separate page, so the conversion is fired here rather
 * than on a thank-you page load.
 */
export function trackLeadConversion() {
  if (typeof window === 'undefined' || !SITE.LEAD_CONVERSION) return
  const w = window as unknown as { gtag?: (...a: unknown[]) => void }
  if (typeof w.gtag !== 'function') return
  w.gtag('event', 'conversion', {
    send_to: SITE.LEAD_CONVERSION,
    value: 1.0,
    currency: 'USD',
  })
}
